export default __webpack_public_path__ + "static/media/pinbidja-color.890187dd.svg";